export const TRACK_PERSONA_ANSWERS = 'TRACK_PERSONA_ANSWERS';
export const TRACK_TUTORIAL_OPEN = 'TRACK_TUTORIAL_OPEN';
export const TRACK_OPEN_ACCOUNT_MANAGEMENT = 'TRACK_OPEN_ACCOUNT_MANAGEMENT';
export const TRACK_OPEN_UPGRADE_MODAL = 'TRACK_OPEN_UPGRADE_MODAL';
export const TRACK_TEMPLATE_PREVIEW_CLICK = 'TRACK_TEMPLATE_PREVIEW_CLICK';
export const TRACK_TEMPLATE_SCROLL = 'TRACK_TEMPLATE_SCROLL';
export const TRACK_TEMPLATE_EDIT = 'TRACK_TEMPLATE_EDIT';
export const TRACK_UPGRADE_PAY_NOW_CLICK = 'TRACK_UPGRADE_PAY_NOW_CLICK';
export const TRACK_PAYMENT_FAILED = 'TRACK_PAYMENT_FAILED';
export const TRACK_PAYMENT_SUCCESS = 'TRACK_PAYMENT_SUCCESS';
export const TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE = 'TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE';
export const TRACK_CURSOR_SELECTION_CHANGE = 'TRACK_CURSOR_SELECTION_CHANGE';
export const TRACK_CURSOR_FILTER_CHANGE = 'TRACK_CURSOR_FILTER_CHANGE';
export const TRACK_IMAGE_IMPORT_CLICK = 'TRACK_IMAGE_IMPORT_CLICK';
export const TRACK_IMAGE_LIBRARY_CLICK = 'TRACK_IMAGE_LIBRARY_CLICK';
export const TRACK_IMAGE_SEARCH = 'TRACK_IMAGE_SEARCH';
export const TRACK_AUDIO_OPEN = 'TRACK_AUDIO_OPEN';
export const TRACK_CURSOR_SETTINGS_OPEN = 'TRACK_CURSOR_SETTINGS_OPEN';
export const TRACK_TOGGLE_GRID = 'TRACK_TOGGLE_GRID';
export const TRACK_OPEN_DOWNLOAD = 'TRACK_OPEN_DOWNLOAD';
export const TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS = 'TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS';
export const TRACK_AUDIO_IMPORT_CLICK = 'TRACK_AUDIO_IMPORT_CLICK';
export const TRACK_AUDIO_PLAY = 'TRACK_AUDIO_PLAY';
export const TRACK_PLAY_SCRIBE = 'TRACK_PLAY_SCRIBE';
export const TRACK_OPEN_SCRIBE = 'TRACK_OPEN_SCRIBE';
export const TRACK_FREE_TRANSFORM_SELECTED = 'TRACK_FREE_TRANSFORM_SELECTED';
export const TRACK_FLIP_ELEMENT = 'TRACK_FLIP_ELEMENT';
export const TRACK_SELECT_FONT = 'TRACK_SELECT_FONT';
export const TRACK_ALIGN_TEXT = 'TRACK_ALIGN_TEXT';
export const TRACK_BOLD_TEXT = 'TRACK_BOLD_TEXT';
export const TRACK_ITALIC_TEXT = 'TRACK_ITALIC_TEXT';
export const TRACK_CHANGE_ELEMENT_COLOR = 'TRACK_CHANGE_ELEMENT_COLOR';
export const TRACK_DELETE_ELEMENT = 'TRACK_DELETE_ELEMENT';

export const trackPersonaAnswers = (answers, date, userTriggered = false) => ({
  type: TRACK_PERSONA_ANSWERS,
  answers,
  date,
  userTriggered
});

export const trackTutorialOpen = () => ({ type: TRACK_TUTORIAL_OPEN });

export const trackOpenAccountManagement = () => ({ type: TRACK_OPEN_ACCOUNT_MANAGEMENT });

export const trackOpenUpgradeModal = (trigger, extraEventProps = {}) => ({
  type: TRACK_OPEN_UPGRADE_MODAL,
  trigger,
  extraEventProps
});

export const trackTemplatePreviewClick = (template, category) => ({
  type: TRACK_TEMPLATE_PREVIEW_CLICK,
  template,
  category
});

export const trackTemplateScroll = category => ({
  type: TRACK_TEMPLATE_SCROLL,
  category
});

export const trackTemplateEdit = (title, category, triggerLocation) => ({
  type: TRACK_TEMPLATE_EDIT,
  title,
  category,
  triggerLocation
});

export const trackUpgradePayNowClick = () => ({ type: TRACK_UPGRADE_PAY_NOW_CLICK });
export const trackPaymentFailed = reason => ({ type: TRACK_PAYMENT_FAILED, reason });
export const trackPaymentSuccess = () => ({ type: TRACK_PAYMENT_SUCCESS });
export const trackDownloadFormatSelectionChange = (format, scribe) => ({
  type: TRACK_DOWNLOAD_FORMAT_SELECTION_CHANGE,
  format,
  scribe
});

export const trackCursorSelectionChange = (cursorId, scribeId) => ({
  type: TRACK_CURSOR_SELECTION_CHANGE,
  cursorId,
  scribeId
});

export const trackCursorFilterChange = (category, scribeId) => ({
  type: TRACK_CURSOR_FILTER_CHANGE,
  category,
  scribeId
});

export const trackImageImportClick = scribeId => ({ type: TRACK_IMAGE_IMPORT_CLICK, scribeId });
export const trackImageLibraryClick = (library, scribeId) => ({ type: TRACK_IMAGE_LIBRARY_CLICK, library, scribeId });
export const trackImageSearch = (query, scribeId) => ({ type: TRACK_IMAGE_SEARCH, query, scribeId });

export const trackAudioOpen = scribeId => ({ type: TRACK_AUDIO_OPEN, scribeId });
export const trackCursorSettingsOpen = scribeId => ({ type: TRACK_CURSOR_SETTINGS_OPEN, scribeId });
export const trackToggleGrid = (scribeId, gridlinesOn, eventTrigger) => ({
  type: TRACK_TOGGLE_GRID,
  scribeId,
  gridlinesOn,
  eventTrigger
});
export const trackOpenDownload = (scribeId, gridlinesOn) => ({ type: TRACK_OPEN_DOWNLOAD, scribeId });

export const trackUpdateScribeBackgroundSettings = (scribeId, colorType, gradientType) => ({
  type: TRACK_UPDATE_SCRIBE_BACKGROUND_SETTINGS,
  scribeId,
  colorType,
  gradientType
});

export const trackAudioImportClick = (scribeId, audioType) => ({ type: TRACK_AUDIO_IMPORT_CLICK, scribeId, audioType });

export const trackAudioPlay = (audioSource, scribeId, audioType, duration) => ({
  type: TRACK_AUDIO_PLAY,
  audioSource,
  scribeId,
  audioType,
  duration
});

export const trackPlayScribe = (scribeId, button, sceneCount, eventTrigger) => ({
  type: TRACK_PLAY_SCRIBE,
  scribeId,
  button,
  sceneCount,
  eventTrigger
});

export const trackOpenScribe = scribeId => ({
  type: TRACK_OPEN_SCRIBE,
  scribeId
});

export const trackFreeTransformSelected = (selected, elementType, scribeId) => ({
  type: TRACK_FREE_TRANSFORM_SELECTED,
  selected,
  elementType,
  scribeId
});

export const trackFlipElement = (direction, elementType, scribeId) => ({
  type: TRACK_FLIP_ELEMENT,
  direction,
  elementType,
  scribeId
});

export const trackSelectFont = (fontName, scribeId) => ({
  type: TRACK_SELECT_FONT,
  fontName,
  scribeId
});

export const trackAlignText = (alignment, scribeId) => ({
  type: TRACK_ALIGN_TEXT,
  alignment,
  scribeId
});

export const trackBoldText = (selected, scribeId) => ({
  type: TRACK_BOLD_TEXT,
  selected,
  scribeId
});

export const trackItalicText = (selected, scribeId) => ({
  type: TRACK_ITALIC_TEXT,
  selected,
  scribeId
});

export const trackChangeElementColor = ({
  elementType,
  colorType,
  gradientDirection,
  colorTab,
  opacity,
  scribeId,
  colorLayer,
  imageName
}) => ({
  type: TRACK_CHANGE_ELEMENT_COLOR,
  elementType,
  colorType,
  gradientDirection,
  colorTab,
  opacity,
  scribeId,
  colorLayer,
  imageName
});

export const trackDeleteElement = (scribeId, eventTrigger) => ({
  type: TRACK_DELETE_ELEMENT,
  scribeId,
  eventTrigger
});
